import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
import { API_PATH } from "../../utils/apis";

const initialState = {
  isLoading: false,
  error: false,
  search: "",
  page: 0,
  perPage: 10,
  insights: [],
  summary: {},
  salesBreakdown: [],
  sortBy: null,
  filters: {
    method: "",
  },
};

const slice = createSlice({
  name: "insight",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getSuccess(state, action) {
      state.isLoading = false;
      state.insights = action.payload.data;
      state.summary = action.payload.summary || {};
      state.salesBreakdown = action.payload.salesBreakdown || [];
    },
    //  SORT & FILTER POSTS
    sortBy(state, action) {
      state.sortBy = action.payload;
    },
    filter(state, action) {
      state.filters.method = action.payload.method;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filter, sortBy } = slice.actions;

export function getInsights(filter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(API_PATH.insights, {
        get: "",
        ...filter,
      });
      const { status, data, summary, salesBreakdown } = response.data;
      if (status === "success") {
        dispatch(slice.actions.getSuccess({ data, summary, salesBreakdown }));
      } else {
        dispatch(
          slice.actions.hasError(
            new Error(
              "We cannot fetch your insights at the moment! Please check back later."
            )
          )
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

